import React from "react";
import styles from "./Paginator.module.scss";
import {PaginatorPropsInterface} from "./Paginator.props.interface";
import ArrowIcon from '../../assets/icons/16/arrow.svg'
import Select from "../Select/Select";
import Button from "../Button";

const Paginator: React.FC<PaginatorPropsInterface> = (
    {
        page = 1,
        size = 20,
        sizes = {10: 10, 20: 20, 50: 50, 100: 100},
        last = 20,
        type = 'secondary',
        disabled = false,
        theme = 'ghost',
        direction = ['top'],
        onPage,
        onSize,
        ...rest
    }) => {

    const pages: any[] = [];
    const ellipsis: string = '...';

    const addEllipsis = (start: number, end: number) => {
        end - start > 1 ? pages.push(ellipsis) : null
    }

    const addPages = (start: number, end: number) => {
        for (let i = start; i <= end; i++) pages.push(i)
    }

    if (last <= 7) {
        addPages(1, last);
    } else if (page <= 4) {
        addPages(1, 5);
        addEllipsis(5, last);
        pages.push(last);
    } else if (page >= last - 3) {
        pages.push(1);
        addEllipsis(1, last - 5);
        addPages(last - 4, last);
    } else {
        pages.push(1);
        addEllipsis(1, page - 2);
        addPages(page - 1, page + 1);
        addEllipsis(page + 2, last);
        pages.push(last);
    }

    return (
        <div className={styles.container} {...rest}>
            <Button
                disabled={page == 1 || disabled}
                size={'medium'}
                theme={theme}
                type={type}
                onClick={() => onPage ? onPage(page - 1) : null}>
                <div className={styles.icon}>
                    <ArrowIcon/>
                </div>
            </Button>
            {pages.map((item, pageIdx) => <div key={pageIdx}>
                {item === ellipsis ? <div className={styles.ellipsis}>
                    <Button
                        size={'medium'}
                        type={type}
                        disabled={disabled}
                        theme={theme}>
                        {ellipsis}
                    </Button>
                </div> : <Button
                    size={'medium'}
                    type={type}
                    disabled={disabled}
                    theme={item === page ? 'default' : theme}
                    onClick={() => onPage ? onPage(item) : null}>
                    {item}
                </Button>}
            </div>)}
            <Button
                disabled={page == last || disabled}
                size={'medium'}
                theme={theme}
                type={type}
                onClick={() => onPage ? onPage(page + 1) : null}>
                <div className={[styles.icon, styles.next].filter(x => x ?? x).join(' ')}>
                    <ArrowIcon/>
                </div>
            </Button>
            {sizes && Object.keys(sizes).length ? <div className={styles.size}>
                <h6>
                    Показывать
                </h6>
                <Select
                    direction={direction}
                    placeholder={'Не выбрано'}
                    size={'small'}
                    value={size || null}
                    disabled={disabled}
                    data={sizes}
                    visibilityItems={5}
                    onChange={(event: number | string | null) => onSize ? onSize(event) : null}
                />
            </div> : null}
        </div>
    );
};

export default Paginator;
